import { __awaiter } from "tslib";
import { DevicePermissionStorageService, PermissionStatus, } from '@office-start/metaos-hub-sdk';
export class AppHostDevicePermissionService {
    constructor(appId, userId, askForConsentCallback) {
        this.storageService = new DevicePermissionStorageService(appId, userId);
        this.askForConsentCallback = askForConsentCallback;
    }
    requestUserConsentForPermission(permission) {
        return __awaiter(this, void 0, void 0, function* () {
            let status = yield this.storageService.getPermissionStatus(permission);
            if (status === PermissionStatus.NeverAsked) {
                status = yield this.askForConsentCallback(permission);
            }
            return Promise.resolve({
                permission,
                status,
            });
        });
    }
}
//# sourceMappingURL=AppHostDevicePermissionService.js.map